import { authClient, API } from "../index";

// Count all configuraciones
export const countConfiguraciones = () => {
  return authClient().get(`${API}/configuracion/count`);
};

// Get all configuraciones
export const getConfiguraciones = () => {
  return authClient().get(`${API}/configuracion`);
};

// Get configuracion by id
export const getConfiguracionById = (id) => {
  return authClient().get(`${API}/configuracion/${id}`);
};

// Update configuracion
export const updateConfiguracion = (id, configuracion) => {
  return authClient().put(`${API}/configuracion/${id}`, configuracion);
};

// Create configuracion
export const postConfiguracion = (configuracion) => {
  return authClient().post(`${API}/configuracion`, configuracion);
};

// Delete configuracion
export const deleteConfiguracion = (id) => {
  return authClient().delete(`${API}/configuracion/${id}`);
};
